/**
 *
 * @param {*} node
 * @param {string} selector
 * @returns {Element|null}
 */
export function closest(node, selector) {
  if (node instanceof Element) {
    return node.closest(selector)
  }
  if (node instanceof Node) {
    return closest(node.parentElement, selector)
  }
  return null
}

/**
 *
 * @param {*} node
 * @param {*} otherNode
 */
export function contains(node, otherNode) {
  return (
    node instanceof Node &&
    otherNode instanceof Node &&
    node.contains(otherNode)
  )
}
